import { socketMessageStream } from "../../utils/socketStream";
import { filter, first, map } from "rxjs/operators";

import chat from "../../store/modules/chat";

export const waitForChatAgents = () => {
    const reelAgents = chat.state.chatAgents.filter((x) => x._id !== "chatbot");
    if (reelAgents.length) {
        return Promise.resolve(reelAgents);
    } else {
        return socketMessageStream
            .pipe(
                filter((x) => x.cmd === "chat_agents"),
                map((x) => x.data),
                first()
            )
            .toPromise();
    }
};



// WEBPACK FOOTER //
// ./src/components/util/waitForChatAgents.js